import mod from 'onesignal-cordova-plugin';

export const OneSignal: typeof mod =
  (mod as unknown as { default?: typeof mod }).default ?? mod;

export { OSNotificationPermission } from 'onesignal-cordova-plugin';
